import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson6 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
         // This is a single line comment
         #This is a single line comment
        ?>

        `
      );
      const code1 = (
        'text',
        `
        <?php
          /* This is a multiple line comment */
        ?>

        `
      );




  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Comments</strong></h3>

    <p>PHP supports two types of comments: single-line and multi-line.</p>
    <p>Here is an example of a single-line comment:</p>
    <CopyBlock
    language={"php"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
   <br />
    <p>And here is an example of a multi-line comment:</p>
    <CopyBlock
    language={"php"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>Comments are used to add notes or explanations to your code. They are ignored by the PHP interpreter,
    so they have no effect on the execution of your code.
    They are useful for documenting your code, making it easier to understand and maintain.</p>
    <p>It is a good practice to include comments in your code to help others understand what you are doing, especially if you are working on a team or sharing your code with others.</p>

    </div>
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson6
